import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div<{ $isShow: boolean }>`
	width: 100%;
	height: 100%;
	overflow: auto;
	display: ${(props) => (props.$isShow ? 'flex' : 'none')};
	flex-direction: column;
	gap: 1.5rem;
	align-items: center;
	justify-content: flex-start;
`;

export const list = styled.div`
	width: 100%;
	display: flex;
	gap: 1rem;
	align-items: center;
	justify-content: flex-start;
	flex-wrap: wrap;
`;

export const item = styled.div<{ $isSelect: boolean }>`
	position: relative;
	padding: 1rem;
	cursor: pointer;
	border: 1px solid
		${(props) =>
			props.$isSelect ? color.system.info : color.interface.lightGray2};
	border-radius: 5px;

	> p {
		color: ${color.interface.lightGray};
		font-size: 1.4rem;
	}
`;

export const checkedItem = styled.div`
	position: absolute;
	display: flex;
	align-items: center;
	justify-content: center;
	top: 0;
	right: 0;
	background-color: ${color.system.info};
	border-top-right-radius: 3px;
	border-bottom-left-radius: 5px;
	padding: 2px;

	> svg {
		color: ${color.interface.white};
		font-size: 8px;
	}
`;

export const centralize = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
	align-items: center;
	justify-content: center;
`;

export const noPages = styled.p`
	font-size: 1.4rem;
	font-family: nunito-bold;
	color: ${color.interface.darkgray};
`;

export const infos = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	align-items: flex-start;
	justify-content: center;

	> h2 {
		font-size: 2.5rem;
		color: ${color.system.info};
	}

	> p {
		font-size: 1.3rem;
		color: ${color.interface.lightGray};
	}
`;
